import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";
import { IViewData, ChartOptions } from "../../scripts/ah.mb.ui.view-builders";
import { ModelNotifier } from "../../scripts/model-notifier";

import { GoogleChartRenderer } from "../../scripts/ah.mb.googleChartRenderer";
import { ReportServices } from "../../scripts/ah.mb.report-services";

import { IDownloadReportsModel } from "../../entities/download-reports-model";
import { INodeCommodities } from "../../scripts/ah.mb.commodity-and-units-rec";

export interface IReportCarouselConfig {
    modelId: string;
    subject: string;
    reportTypeFilter: "All" | "Maps";
    initialViewName: string;
    nodeCommodities: INodeCommodities;
}


@Component
export default class ReportCarousel extends Vue {

    @Prop()
    value: IReportCarouselConfig;

    @Watch("value", { deep: true })
    valueChanged() {

        this.updateView();

    }

    needsCommodity: boolean = false;
    commoditySelectList: Array<string> = [];
    selectedCommodity: string = "";


    private reportServices: ReportServices = null;
    private chartRenderer: GoogleChartRenderer;
    private currentReportIndex: number;
    private reportList: any;

    downloadReportsModel: IDownloadReportsModel =
        {
            mode: "bySubjectNode", modelId: "", createPivots: false, format: "excel", reportNodePathAndNames: [], singleSheet: false,
            reportNames: [],
            recursive: false
        }
    showDownloadReportsDialog: boolean = false;

    data() {
        return {currentReportName: this.currentReportName}
    }

    currentReportName: string;

    showReport(modelId: string, nodePathAndName: string, reportServices: ReportServices,
        reportList: any, queryString: string,
        target: JQuery) {

        const reportName = reportList[this.currentReportIndex].name;

        // Old hardcoded way of determining if report needs filters
        var needsTimePoint = reportName === "Supply by Levelized Cost" ||
            reportName === "Supply Stack" ||
            reportName === "Hub Supply Stack" ||
            reportName === "Aggregate Supply Stack" ||
            reportName === "Demand Curve";
        var  needsSubTime = reportName === "Supply Curve" ||
            reportName === "Supply Stack" ||
            reportName === "Hub Supply Stack" ||
            reportName === "Aggregate Supply Stack" ||
            reportName === "Demand Curve";


        // New way
        if (reportList[this.currentReportIndex].requiredFilters) {
            needsTimePoint = needsTimePoint || reportList[this.currentReportIndex].requiredFilters.indexOf("TimePoint") > -1;
            needsSubTime = needsSubTime || reportList[this.currentReportIndex].requiredFilters.indexOf("SubTime") > -1;
        }

        switch (reportName) {
            case "Demand Curve": {
                this.needsCommodity = true;
                this.commoditySelectList = this.value.nodeCommodities.inputCommodities.map(p => p.commodity);
                if (this.commoditySelectList && !this.selectedCommodity
                    || !this.commoditySelectList.find(p => p == this.selectedCommodity))
                    this.selectedCommodity = this.commoditySelectList[0];
                break;
            }

            case "Supply Stack":
                {
                    this.needsCommodity = true;
                    this.commoditySelectList = this.value.nodeCommodities.outputCommodities.map(p => p.commodity);
                    if ((this.commoditySelectList && !this.selectedCommodity)
                        || !this.commoditySelectList.find(p => p == this.selectedCommodity))
                        this.selectedCommodity = this.commoditySelectList[0];
                    break;
                }

            default:
                {
                    this.needsCommodity = false;
                    this.commoditySelectList = [];
                    this.selectedCommodity = "";
                    break;
                }
        }


        $("#next-report-button").prop("disabled", this.currentReportIndex === reportList.length - 1);
        $("#previous-report-button").prop("disabled", this.currentReportIndex <= 0);

        $("#report-query-string-edit").prop("disabled", !needsTimePoint);
        $("#report-query-string-subtime-edit").prop("disabled", !needsSubTime);


        reportServices.getReportByNodeResults(modelId,
            [nodePathAndName],
            reportName,
            queryString)
            .then((result: any) => {
                this.renderReport(modelId, nodePathAndName, result, reportServices, reportList, target);

            });

    }

    refreshChart() {
        this.showReport(this.value.modelId, this.value.subject, this.reportServices,
            this.reportList, this.getCurrentQueryString(), $("#report-carousel-report-div"));
    }
    

    private reportRendered(modelId: string, nodePathAndName: string, reportServices: ReportServices,
        reportList: any, target: JQuery) {


        const showReportFunc = () =>
            this.showReport(modelId, nodePathAndName, reportServices, reportList, this.getCurrentQueryString(), target);

        $("#report-query-string-edit").off("change");

        $("#report-query-string-edit").on("change", showReportFunc);

        $("#report-query-string-subtime-edit").off("change");
        $("#report-query-string-subtime-edit").on("change", showReportFunc);

        $('#showAsTableCheckbox').off("click");
        $('#showAsTableCheckbox').click(showReportFunc);
    }


    private renderReport(modelId: string, nodePathAndName: string, report: IViewData, reportServices: ReportServices,
        reportList: any, target: JQuery) {

        $("#carousel-report-title").text(`${nodePathAndName}: ${report.title}`);

        const chartOptions: ChartOptions = {
            showLegend: true, showTitle: true,
            showXAxisTitlesFunc: () => true, showYAxisTitlesFunc: () => true,
            backgroundColor: "white"
        };

        const asTable = $("#showAsTableCheckbox").is(":checked");
        this.chartRenderer.forceViewType(asTable ? 4 : -1); // 4 = table

        this.chartRenderer.drawGraph(target, report, chartOptions)
            .then(() => {
                this.currentReportName = report.title;

                this.reportRendered(modelId, nodePathAndName, reportServices, reportList, target);
            });
    }

    private getCurrentQueryString(): string {

        const timePoint = $("#report-query-string-edit").val();
        const term = $("#report-query-string-subtime-edit").val();
        return `${timePoint}|${term}|${this.selectedCommodity}`;

    }

    private reportListReceived(modelId: string, nodePathAndName: string,
        reportServices: ReportServices, initialViewName: string, target: JQuery, reportList: any) {

        this.reportList = reportList;

        $("#previous-report-button").off("click");
        $("#next-report-button").off("click");


        if (initialViewName) {
            const initialViewIndex = reportList.findIndex((value: any) => {
                return value.name === initialViewName;
            });

            this.currentReportIndex = Math.max(0, initialViewIndex);
        }
        else
            this.currentReportIndex = 0;

        $("#next-report-button").click(() => {
            this.currentReportIndex += 1;
            this.showReport(modelId, nodePathAndName, reportServices, reportList, this.getCurrentQueryString(), target);

        });

        $("#previous-report-button").click(() => {
            this.currentReportIndex -= 1;
            this.showReport(modelId, nodePathAndName, reportServices, reportList, this.getCurrentQueryString(), target);

        });

        if (reportList) {
            this.showReport(modelId, nodePathAndName, reportServices, reportList, this.getCurrentQueryString(), target);

        };

    }

    closeDialog() {
        this.$emit("closeButtonClicked");
    }

    updateView() {
        if (this.value && this.value.modelId) {

            this.setupCarousel(this.value.modelId,
                this.value.subject,
                this.value.reportTypeFilter,
                this.reportServices,
                this.value.initialViewName,
                $("#report-carousel-report-div"));
        }
    }

    mounted() {
        const observer = new ModelNotifier();
        this.reportServices = new ReportServices(observer);

        this.chartRenderer = new GoogleChartRenderer();

        this.updateView();

    }

    showPreviousReport(modelId: string, nodePathAndName: string, reportServices: ReportServices,
        target: JQuery) {
    }

    setupCarousel(modelId: string, nodePathAndName: string, reportTypeFilter: "All" | "Maps", reportServices: ReportServices,
        initialViewName: string, target: JQuery) {
        target.empty();

        this.setupTimepointBloodhoid(modelId)
            .then(() => this.setupSubTimeBloodhound(modelId))
        .then(() => reportServices.getReportsByNodes(modelId,
            reportTypeFilter,
            [nodePathAndName],
            this.getCurrentQueryString())
                .then(data  => this.reportListReceived(modelId, nodePathAndName, reportServices, initialViewName, target, data)));
    }

    private setupTimepointBloodhoid(modelId: string): Promise<any> {
        // Download timepoints

        return FetchWrapper.fetch(`/api/1.0/nodes/getnodedata?modelId=${modelId}&nodePathAndName=&variableName=GlobalModelTimeVector`,
            { method: "get" })
            .then(response => response.json())
            //$.get(`/api/1.0/nodes/getnodedata?modelId=${modelId}&nodePathAndName=&variableName=GlobalModelTimeVector`)
            .then(data => {

                var timePoints = data[0].value.map(d => d[1]);


                if (timePoints) {

                    // Input version:
                    //$("#report-query-string-edit")
                    //    .attr({
                    //        max: timePoints[timePoints.length - 1],
                    //        min: timePoints[0]
                    //    });

                    // Dropdown version:
                    $("#report-query-string-edit").empty();
                    const optionList = document.getElementById("report-query-string-edit") as HTMLSelectElement;
                    timePoints.forEach(option =>
                        optionList.add(new Option(option, option)));

                    // Default value;
                    // Try to get initial setting from main form
                    const initialValue = $("#timepoint-edit").val();
                    $("#report-query-string-edit").val(initialValue);

                    //                        this.currentQueryString = initialValue;
                }
            });

    }

    private setupSubTimeBloodhound(modelId: string): Promise<any> {
        // Download timepoints
        return FetchWrapper.fetch(`/api/1.0/nodes/getnodedata?modelId=${modelId}&nodePathAndName=&variableName=SubtimeNames`,
            { method: "get" })
        .then(response => response.json())
            //)

            //    $.get(`/api/1.0/nodes/getnodedata?modelId=${modelId}&nodePathAndName=&variableName=SubtimeNames`)
            .then(data => {


                var subTimes = data[0].value.map(d => d[0]);

                if (subTimes) {

                    $("#report-query-string-subtime-edit").empty();
                    const optionList =
                        document.getElementById("report-query-string-subtime-edit") as HTMLSelectElement;

                    subTimes.forEach(option => {
                        optionList.add(new Option(option, option));

                    });

                    // Default value;
                    // Try to get initial setting from main form
                    const initialValue = $("#subtime-edit").val();
                    $("#report-query-string-subtime-edit").val(initialValue);
                }
            });

    }

    downloadReportClick() {

        //const selection: NodeObject[] = this.modelTree.getSelectedNodes();
        //const reportIds = $.map(selection, n => n.pathAndName);

        this.downloadReportsModel = {
            mode: "bySubjectNode",
            modelId: this.value.modelId,
            singleSheet: false,
            format: "excel",
            reportNodePathAndNames: [this.value.subject],
            createPivots: false,
            reportNames: [this.currentReportName],
            recursive: false
        }
        this.showDownloadReportsDialog = true;
    };

    onDownloadReportsDialogClosed() {
        this.showDownloadReportsDialog = false;

    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/report-carousel/report-carousel.ts